<template>
  <modal
    name="offer-modal-archive"
    :resizable="true"
    :height="'auto'"
    :width="'80%'"
    :scrollable="true"
  >
    <!-- Nagłówek modalu -->
    <div class="modal-header-custom">
      <div class="header-content">
        <h3 class="modal-title">📄 Podgląd oferty</h3>
        <p class="modal-subtitle" v-if="offer.offerNumber">{{ offer.offerNumber }}</p>
      </div>
      <button class="btn-close-modal" @click="$emit('closeModal')">
        ✕
      </button>
    </div>

    <!-- Treść oferty (do druku PDF) -->
    <div class="modal-content-custom">
    <div id="toPrint" class="mx-3">
      <div class="row text-right">
        <div class="col-12">
          <img src="../assets/logo.png" alt="" />
          <p>
            ul. Wąska 4 Zaborze, 43-520 Chybie <br />
            biuro@klim-bud.pl <br />
            tel: 574 559 890
            <br />
            NIP:548-235-02-89<br />
            REGON: 241002771 <br />
            www.klim-bud.pl
          </p>
        </div>
      </div>
      <div class="row text-right">
        <div class="col-12 my-4 mb-3">Chybie dn. {{ date.toLocaleDateString("pl") }}</div>
      </div>
      <div class="row my-4 text-center">
        <div class="col-12">
          <h3 class="my-4">OFERTA CENOWA</h3>
          <h5 v-if="!offer.meeting">{{ offer.offerNumber }}</h5>
          <div v-if="offer.meeting">
            {{offer.contractorName}}<br/>
            {{offer.contractorAddress}}<br/>
            {{offer.contractorNumber}}<br/>
            {{offer.contractor}}
          </div>
          <br /><br />
          <h5 class="my-4" v-html="offer.header2">
            {{ offer.header2 }}
          </h5>
          <br />
          <p class="my-4" v-html="offer.subheader">
            {{ offer.subheader }}
          </p>
        </div>
      </div>

      <div class="html2pdf__page-break"></div>

      <div class="row">
        <div class="col-12 text-right">
           <img src="../assets/logo.png" alt="" />
        </div>
       
      </div>

      <!-- <div class="row text-right">
        <div class="col-12">
          <p>
            ul. Wąska 4 Zaborze, 43-520 Chybie <br />
            biuro@klim-bud.pl <br />
            tel: 504 041 946
            <br />
            NIP:548-235-02-89<br />
            REGON: 241002771 <br />
            www.klim-bud.pl
          </p>
        </div>
      </div> -->

      <div class="row text-center">
        <div class="col-12 my-5">
          <h5 v-html="offer.offerHeader || offer.header">{{ offer.offerHeader || offer.header }}</h5>
        </div>

        <!-- <div class="row">
          <div class="col-12 text-center">
            <img style="max-height: 500px" :src="`${imageUrl}`" alt="" />
          </div>

          <div class="col-3 ml-5 text-center border">
            <small>Uwagi do oferty:</small> <br />
            {{ notice }}
          </div>
        </div> -->

        <table style="font-size: 14px" class="table mt-2 table-sm table-striped">
          <thead>
            <th>Przedmiot</th>
            <th>j.m.</th>
            <th>ilość</th>
            <th>cena netto</th>
            <th>wartość netto</th>
            <th>wartość brutto</th>
          </thead>
          <tbody>
            <tr v-for="item in offer.offer" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ item.measure }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ item.price }}</td>
              <td>{{ (item.amount * item.price).toFixed(2) }}</td>
              <td>{{ (item.amount * item.price * offer.vat).toFixed(2) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td><b>Suma PLN:</b></td>
              <td></td>
              <td></td>
              <td v-if="offer.vat === '1.08'"><b>VAT: 8%</b></td>
              <td v-else><b>VAT: 23%</b></td>
              <td>
                <b>{{ totalPriceNetto }}</b>
              </td>
              <td>
                <b>{{ totalPriceBrutto }}</b>
              </td>
            </tr>
          </tfoot>
        </table>

        <div class="col-12 my-3 text-center">
          <img
            class="img-fluid"
            style="max-height: 350px"
            :src="`${offer.imageUrl}`"
            alt=""
          />
        </div>

        <div class="col-6 my-5 text-center">
          <small>Uwagi do oferty:</small> <br />
          <div v-html="offer.notice"></div>
        </div>
        <div class="col-6 my-5 text-center">
          <small>Wykonawca F.H.U KLIM-BUD:</small> <br />
          {{ offer.user.name }} <br />
          {{ offer.user.phoneNumber }}
        </div>
      </div>
    </div>
    </div>

    <!-- Fixed footer -->
    <div class="modal-footer-custom">
      <div class="footer-left"></div>
      <div class="footer-center">
        <button class="btn-submit" @click="generateOffer(offer)">
          <span class="submit-icon">📝</span>
          Generuj PDF
        </button>
        <button class="btn-cancel" @click="$emit('closeModal')">
          Zamknij
        </button>
      </div>
      <div class="footer-right">
        <button class="btn-edit" @click="openOfferModalEdit(offer)">
          <span class="edit-icon">✏️</span>
          Edytuj
        </button>
      </div>
    </div>

    <offer-modal-archive-edit
      @closeModalEdit="closeModalEdit()"
      :offer="offer"
    ></offer-modal-archive-edit>
  </modal>
</template>
<script>
import html2pdf from "html2pdf.js";
import OfferModalArchiveEdit from "../components/OfferModalArchiveEdit";
export default {
  props: ["offer"],
  data() {
    return {
      // totalPriceNetto: 0,
      // totalPriceBrutto: 0,
      date: new Date(),
    };
  },
  components: {
    "offer-modal-archive-edit": OfferModalArchiveEdit,
  },
  computed: {
    totalPriceNetto() {
      let priceNetto = 0;
      this.offer.offer.forEach((item) => {
        if (item.price) {
          priceNetto += item.price * item.amount;
        }
      });
      return priceNetto.toFixed(2);
    },
    totalPriceBrutto() {
      let priceBrutto = 0;
      this.offer.offer.forEach((item) => {
        if (item.price) {
          priceBrutto += item.price * item.amount * this.offer.vat;
        }
      });
      return priceBrutto.toFixed(2);
    },
  },
  methods: {
    generateOffer() {
      console.log(this.imageUrl);
      console.log(this.offersElements);
      var element = document.getElementById("toPrint");
      html2pdf(element, {
        margin: 0.1,
        filename: prompt("Podaj nazwę pliku"),
        image: { type: "jpeg", quality: 1 },
        html2canvas: { dpi: 192 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      });
    },
    openOfferModalEdit(offer) {
      console.log(offer);
      window.scrollTo(0, 0);
      this.$modal.show("offer-modal-archive-edit");
      this.offer = offer;
      // Prevent navigating to narrower view (default vue-cal behavior).
    },
    closeModalEdit() {
      // this.total();
      setTimeout(() => {
        // this.events = [];
        // console.log(this.installations);
        //   //   const item1 = this.config.chart.items["1"];
        //   //   item1.label = "label changed dynamically";
        //   //   item1.time.end += 2 * 24 * 60 * 60 * 1000;
        // this.setEvents();
      }, 100);
      // this.total();
      this.$modal.hide("offer-modal-archive-edit");
    },
    // total() {
    //   this.totalPriceNetto = 0;
    //   this.totalPriceBrutto = 0;
    //   this.offer.offer.forEach((item) => {
    //     console.log(item + " ->closeModalEdit");
    //     if (item.price) {
    //       this.totalPriceNetto += item.price * item.amount;
    //       this.totalPriceBrutto += item.price * item.amount * this.offer.vat;
    //     }
    //   });
    // },
  },
};
</script>

<style scoped>
/* --- Nagłówek modalu --- */
.modal-header-custom {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 30px 40px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
}

.header-content {
  flex: 1;
}

.modal-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: white;
}

.modal-subtitle {
  margin: 6px 0 0 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
}

.btn-close-modal {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.btn-close-modal:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

/* --- Zawartość modalu --- */
.modal-content-custom {
  padding: 40px;
  margin-bottom: 100px;
  background: white;
}

/* --- Sekcja PDF --- */
#toPrint {
  background: white;
  padding: 30px;
}

/* --- Fixed footer --- */
.modal-footer-custom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 20px 40px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
}

.footer-left {
  flex: 1;
}

.footer-center {
  display: flex;
  gap: 15px;
  align-items: center;
}

.footer-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.btn-submit {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(102, 126, 234, 0.5);
}

.submit-icon {
  font-size: 18px;
}

.btn-cancel {
  background: transparent;
  color: #718096;
  border: none;
  padding: 14px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel:hover {
  color: #2d3748;
  background: #f7fafc;
}

.btn-edit {
  background: #ffc107;
  color: #856404;
  border: none;
  padding: 14px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);
}

.btn-edit:hover {
  background: #ffca2c;
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(255, 193, 7, 0.4);
}

.edit-icon {
  font-size: 16px;
}

/* --- Responsywność --- */
@media (max-width: 768px) {
  .modal-header-custom {
    padding: 20px 25px;
  }

  .modal-title {
    font-size: 22px;
  }

  .modal-content-custom {
    padding: 25px 20px;
  }

  #toPrint {
    padding: 20px;
  }

  .modal-footer-custom {
    flex-direction: column;
    padding: 15px 20px;
    gap: 10px;
  }

  .footer-left,
  .footer-right {
    display: none;
  }

  .footer-center {
    flex-direction: column;
    width: 100%;
  }

  .btn-submit,
  .btn-cancel,
  .btn-edit {
    width: 100%;
    justify-content: center;
  }

  .footer-right {
    display: flex;
    width: 100%;
  }
}
</style>
